module.exports = __webpack_public_path__ + "img/menu_arrow.dfbae30b.svg";